import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { CurrencyExchangeRateQuery, CurrencyExchangeRateQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(CurrencyExchangeRateQuery)
@Wrapper(CurrencyExchangeRateQueryHandlerBase)
export class CurrencyExchangeRateQueryHandler {
    public constructor(
        http: Http
    ) {}
}
